import React from 'react';
import {
    Button,
    message,
    Popconfirm,
} from 'antd';
import {
    FaTrashAlt
  } from "react-icons/fa"; 
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../config/axios';

export default function DeletePopupButton({ data }) {

    const [messageApi, contextHolder] = message.useMessage();
    const queryClient = useQueryClient();
    const { mutate } = useMutation({
        mutationFn: ({ _id }) => {
            axios
                .delete(`/api/products/${_id}`)
                .then(() =>  queryClient.invalidateQueries(['/api/products/findCourses']))
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'Something went wrong please check you data or contact Admin.',
                    });
                })
        }
    });

    const confirm = (e) => mutate(data);

    return (
        <div>
            {contextHolder}
            <Popconfirm
                title="Delete item"
                description="Confirm delete item Yes or No?"
                onConfirm={confirm}
                okText="Yes"
                cancelText="No"
            >
                <Button danger icon={<FaTrashAlt />} type='text' />
            </Popconfirm>
        </div>
    )
}
